import { useTranslation } from 'react-i18next';
import { Table, Typography } from '@thinknet-gmbh/platform-common-ui';

import EmployeeRowSelect from './employee-row-select.component';
import { IDocumentImporterPreviewTableProps } from '../../document-importer-list.interfaces';
import { StyledPreviewTableContainer } from './document-importer-preview-table.styles';

const DocumentImporterPreviewTable = ({
  dataSource,
  handleEmployeeChange,
  employeesOptions,
  loading,
  isPreview,
}: IDocumentImporterPreviewTableProps) => {
  const { t } = useTranslation(['common', 'documentImporter']);

  return (
    <StyledPreviewTableContainer
      loading={loading}
      dataSource={dataSource}
      pagination={false}
      rowKey={record => record?._id || record?.uid}
      t={t}
    >
      <Table.Column
        width={'50%'}
        title={t('documentImporter:labels.file')}
        sorter={false}
        render={({ name }) => <Typography>{name}</Typography>}
      />

      <Table.Column
        width={'50%'}
        title={t('documentImporter:labels.employee')}
        render={record => (
          <EmployeeRowSelect
            record={record}
            isPreview={isPreview}
            employeesOptions={employeesOptions}
            handleEmployeeChange={handleEmployeeChange}
            t={t}
          />
        )}
      />
    </StyledPreviewTableContainer>
  );
};

export default DocumentImporterPreviewTable;
